import { render, staticRenderFns } from "./TextingMoadl.vue?vue&type=template&id=ca7b2656&scoped=true&"
import script from "./TextingMoadl.vue?vue&type=script&lang=js&"
export * from "./TextingMoadl.vue?vue&type=script&lang=js&"
import style0 from "./TextingMoadl.vue?vue&type=style&index=0&id=ca7b2656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7b2656",
  null
  
)

export default component.exports